export default __webpack_public_path__ + "static/media/not-sent-no-anomalies-icon.4fd2181a.svg";